// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkQueuesItem_root","icon":"WorkQueuesItem_icon","label":"WorkQueuesItem_label"};